import React from 'react';

const Hero = () => {
  return (
    <section id="hero" className="d-flex align-items-center text-center" style={{ minHeight: '100vh' }}>
      <div className="container">
        <h1 className="display-2 fw-bold" data-aos="fade-up">Recuperación Muscular Inmediata</h1>
        <p className="lead my-4" data-aos="fade-up" data-aos-delay="100">LactiGo es el gel de uso tópico diseñado para atletas que buscan maximizar su rendimiento y acelerar la recuperación. Siente el alivio, siente la diferencia.</p>
        <a href="#image-carousel" className="btn btn-primary btn-lg" data-aos="fade-up" data-aos-delay="200">Descubre sus Beneficios</a>
      </div>
    </section>
  );
};

export default Hero;